import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import { debug } from '../../../utils';
import { getProfile, postProfile } from '../../models/Profile';
import Button from '../../components/Button/Button';
const log = debug('lego:Profile.tsx');
const styles = require('./Profile.less') as any;
import groupBy from 'lodash/groupBy';
import defaultTo from 'lodash/defaultTo';
import get from 'lodash/get';
import { Name, Gender, Describes, Birth, Diagnosis, Zipcode, Impairments, AT } from './ProfileFields';
import validate from './validate'
import isEmpty from 'lodash/isEmpty'

import { handleSubmissionError } from '../utils'

const NUMBER_OF_WIZARD_PAGES = 4;
import { getFormValues } from 'redux-form';
const mapStateToProps = (state, ownProps) => ({
		initialValues: get(state, 'profile.data', {} as any),
		profile: get(state, 'profile.data', {} as any),
		selected_condition: defaultTo(parseInt(ownProps.location.query.condition), 0),
		selected_fn: defaultTo(parseInt(ownProps.location.query.fn), 0),
  firstName: get(getFormValues('profileForm')(state), 'name', '').split(' ')[0],
});
const mapDispatchToProps = dispatch => ({
	getProfile: (...args) => dispatch(getProfile(...args)),
	postProfile: (...args) => dispatch(postProfile(...args)),
	submitProfile: (...args) => handleSubmissionError(dispatch(postProfile(...args))),
})
@connect(mapStateToProps, mapDispatchToProps)
@reduxForm({form: 'profileForm', enableReinitialize: true, keepDirtyOnReinitialize: true, validate})
class Profile extends React.Component<any,any> {
		toggleCondition(id) {
				const router = this.props.router;
				const params = {
						condition: this.props.selected_condition == id ? -1 : id
				};
				router.replace(router.createPath({
						pathname: this.props.location.pathname,
						query: params
				}));
		}

    componentWillMount() {
        if (this.props.profile.completion < NUMBER_OF_WIZARD_PAGES) {
            this.props.router.replace(`/wizard/`)
        }
    }

		render() {
				const { profile, selected_condition, selected_fn, firstName,
								submitting, pristine, reset, handleSubmit } = this.props;

				return (
						<div id='ProfilePage'>
								<form onSubmit={handleSubmit(this.props.submitProfile)}>
										<h1>Health Profile</h1>
										<div>
												<div className={styles.demographics}>
	  												<Name />
  													<Describes firstName={firstName} />
														<Birth />
														<Gender />
														<Zipcode />
												</div>
                        <div>
                            <h2>Health Conditions</h2>
												    <Impairments onClick={this.toggleCondition.bind(this)} selected={[selected_condition]} />
                        </div>
                        <div>
                            <h2>Assistive Technology</h2>
												    <AT />
                        </div>
										</div>
                    <div style={{textAlign: 'right'}}>
										  <Button type="button" kind="secondary" disabled={pristine || submitting}
onClick={reset}>Reset</Button>
										  <Button type="submit" disabled={pristine || submitting}>Save</Button>
                    </div>
								</form>
						</div>
				);
		}
}

import classNames from 'classnames';


export default withRouter(Profile);



// WEBPACK FOOTER //
// ./src/app/containers/Profile/Profile.tsx